/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_log_out6 = /** @type {(inputs: {}) => string} */ () => {
	return `Log out`
};

const fr_log_out6 = /** @type {(inputs: {}) => string} */ () => {
	return `Se déconnecter`
};

const de_log_out6 = /** @type {(inputs: {}) => string} */ () => {
	return `Ausloggen`
};

const es_log_out6 = /** @type {(inputs: {}) => string} */ () => {
	return `Finalizar la sesión`
};

const it_log_out6 = /** @type {(inputs: {}) => string} */ () => {
	return `Disconnettersi`
};

const ar_log_out6 = /** @type {(inputs: {}) => string} */ () => {
	return `تسجيل الخروج`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const log_out6 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.log_out6(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("log_out6", locale)
	if (locale === "en") return en_log_out6(inputs)
	if (locale === "fr") return fr_log_out6(inputs)
	if (locale === "de") return de_log_out6(inputs)
	if (locale === "es") return es_log_out6(inputs)
	if (locale === "it") return it_log_out6(inputs)
	return ar_log_out6(inputs)
};
export { log_out6 as "LOG_OUT" }